import { render, staticRenderFns } from "./LayoutSection.vue?vue&type=template&id=44e1eedb&functional=true&"
import script from "./LayoutSection.vue?vue&type=script&lang=ts&"
export * from "./LayoutSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports